import React, { useCallback, useState, useMemo } from 'react';
import ProductConfigurationContext from './ProductConfigurationContext';
import { useQuery } from '@apollo/react-hooks';
import ConfigPrice from './ConfigPrice.gql';
import produce from 'immer';
const ProductConfigurationProvider = ({ product, children }) => {
    const { configurations } = product;
    const [ids, setIds] = useState(configurations.map(config => config.options[0].id));
    const selectOption = useCallback(function selectOption(option, config) {
        const idx = configurations.indexOf(config);
        setIds(curr => produce(curr, draft => {
            draft[idx] = option.id;
        }));
    }, [configurations]);
    const getSelectedValue = useCallback(function getSelectedValue(config) {
        const idx = configurations.indexOf(config);
        const id = ids[idx];
        return config.options.find(option => option.id === id).name;
    }, [configurations, ids]);
    // Creating the variables for the product price query (with configs)
    const priceQueryVars = useMemo(() => {
        return { id: product.id, options: ids.map(id => ({ optionId: id })) };
    }, [product.id, ids]);
    const priceQuery = useQuery(ConfigPrice, {
        variables: priceQueryVars,
        partialRefetch: true
    });
    const value = useMemo(() => {
        var _a;
        return ({
            configurations,
            configurationPrice: (_a = priceQuery.data) === null || _a === void 0 ? void 0 : _a.product.configurationPrice,
            loading: priceQuery.loading,
            selectOption,
            getSelectedValue,
            ids
        });
    }, [
        configurations,
        priceQuery.data,
        priceQuery.loading,
        selectOption,
        getSelectedValue,
        ids
    ]);
    return (React.createElement(ProductConfigurationContext.Provider, { value: value }, children));
};
const ConditionalProvider = ({ product, children }) => (product === null || product === void 0 ? void 0 : product.hasConfigurations) ? (React.createElement(ProductConfigurationProvider, { product: product }, children)) : (React.createElement(React.Fragment, null, children));
export default ConditionalProvider;
//# sourceMappingURL=ProductConfigurationProvider.js.map